import DragDropController from '@/js/Webmail/DragDrop/DragDropController';
export {DragDropDirective as default}


const DragDropDirective = {
  created(el, binding) {
    const hover_active = binding.value.hover_class_active || 'drag-over';

    el.onEnter = () => {
      if(!binding.value.hover_events || !binding.value.hover_events.includes(DragDropController.drags.event)){
        return;
      }

      if(!el.hover_count){
        el.hover_count = 0;
        el.classList.add(hover_active);
      }

      if(el.hover_count === 0){
        DragDropController.onDragEnter(binding.value.drop_data, binding.value.hover_events, binding.value.drop_suffix);
      }

      el.hover_count++;
    }

    el.onDrop = (event) => {
      event.preventDefault();
      DragDropController.onDragDrop(binding.value.drop_data, binding.value.hover_events, binding.value.drop_suffix);
      el.hover_count = 0;

      el.classList.remove(hover_active);
    };

    el.onLeave = () => {
      el.hover_count--

      if(el.hover_count !== 0){
        return;
      }

      el.classList.remove(hover_active);
      DragDropController.onDragLeave(binding.value.drop_data, binding.value.hover_events, binding.value.drop_suffix);
    };

    el.onOver = (event) => {
      event.preventDefault();
    }
  },
  mounted(el) {
    el.addEventListener('drop'      , el.onDrop);
    el.addEventListener('dragover'  , el.onOver);
    el.addEventListener('dragenter' , el.onEnter);
    el.addEventListener('dragleave' , el.onLeave);
  },
  unmounted(el) {
    el.removeEventListener('dragover' , el.onEnter);
    el.removeEventListener('dragleave', el.onDrop);
    el.removeEventListener('drop'     , el.onLeave);
    el.removeEventListener('dragover' , el.onOver);
  },
};
